<template>
  <div>
    <!-- administrators section  -->
    <div class="bg-white">
      <div class="flex flex-col gap-7.5 px-5 md:px-7.5 lg:px-10 1.5xl:px-12.5">
        <div class="mb-[32px] sm:mb-[40px] md:mb-[56px] lg:mb-[70px] text-left xm:text-center">
          <h2 class="mb-[12px] sm:mb-[16px] md:mb-[20px] lg:mb-[25px]">
            {{ $t(`landingPage.${empoweringRoleSContent.heading}`) }}
          </h2>
          <p1 class="text-left xm:text-center">
            <div class="xm:mx-14 xl:mx-[90px]">
              {{ $t(`landingPage.${empoweringRoleSContent.paragraph}`) }}
            </div>
          </p1>
        </div>
        <div class="flex flex-col md:flex-row justify-between">
          <!-- administrators -->
          <div class="w-full md:w-[calc(50%-10px)] bg-primary-purple-50 rounded-19 mb-5 md:mb-0">
            <div class="w-full bg-primary-purple-50 p-3 lg:p-5 rounded-[19px]">
              <h3
                class="mb-2 lg:mb-3 1.5xl:mb-4 text-lg leading-6 lg:text-xl lg:leading-7 1.5xl:text-3xl 1.5xl:leading-[42px]"
              >
                Simplifying Administration by Automation
              </h3>
              <div ref="adminCarousel" class="owl-carousel owl-theme">
                <div v-for="(item, index) in administratorsCarouselData" :key="index">
                  <img
                    :src="item.logo"
                    class="w-full rounded-19 carousel-height bg-primary-purple-200 p-2.5"
                  />
                  <h6 v-if="item.title" class="text-primary-gray-800 text-center mt-1">
                    {{ item.title }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <!-- teacher -->
          <div class="w-full md:w-[calc(50%-10px)] bg-primary-purple-50 rounded-19 mb-5 md:mb-0">
            <div class="w-full bg-primary-purple-50 p-3 lg:p-5 rounded-[19px]">
              <h3
                class="mb-2 lg:mb-3 1.5xl:mb-4 text-lg leading-6 lg:text-xl lg:leading-7 1.5xl:text-3xl 1.5xl:leading-[42px]"
              >
                Equipping Teachers with Modern Tools
              </h3>
              <div ref="teacherCarousel" class="owl-carousel owl-theme">
                <div v-for="(item, index) in teachersCarouselData" :key="index">
                  <img
                    :src="item.logo"
                    class="w-full rounded-19 carousel-height bg-primary-purple-200 p-2.5"
                  />
                  <h6 v-if="item.title" class="text-primary-gray-800 text-center mt-1">
                    {{ item.title }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row justify-between">
          <!-- student -->
          <div class="w-full md:w-[calc(50%-10px)] bg-primary-purple-50 rounded-19 mb-5 md:mb-0">
            <div class="w-full bg-primary-purple-50 p-3 lg:p-5 rounded-[19px]">
              <h3
                class="mb-2 lg:mb-3 1.5xl:mb-4 text-lg leading-6 lg:text-xl lg:leading-7 1.5xl:text-3xl 1.5xl:leading-[42px]"
              >
                Enhancing Learning Experience for Students
              </h3>
              <div ref="studentCarousel" class="owl-carousel owl-theme">
                <div v-for="(item, index) in studentsCarouselData" :key="index">
                  <img
                    :src="item.logo"
                    class="w-full rounded-19 carousel-height bg-primary-purple-200 p-2.5"
                  />
                  <h6 v-if="item.title" class="text-primary-gray-800 text-center mt-1">
                    {{ item.title }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <!-- guardian -->
          <div class="w-full md:w-[calc(50%-10px)] bg-primary-purple-50 rounded-19 mb-5 md:mb-0">
            <div class="w-full bg-primary-purple-50 p-3 lg:p-5 rounded-[19px]">
              <h3
                class="mb-2 lg:mb-3 1.5xl:mb-4 text-lg leading-6 lg:text-xl lg:leading-7 1.5xl:text-3xl 1.5xl:leading-[42px]"
              >
                Increasing Guardians' Trust and Satisfaction
              </h3>
              <div ref="guardianCarousel" class="owl-carousel owl-theme">
                <div v-for="(item, index) in guardiansCarouselData" :key="index">
                  <img
                    :src="item.logo"
                    class="w-full rounded-19 carousel-height bg-primary-purple-200 p-2.5"
                  />
                  <h6 v-if="item.title" class="text-primary-gray-800 text-center mt-1">
                    {{ item.title }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userRoles from '@src/constants/user-roles.contants.js'

import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'

export default {
  data() {
    return {
      adminImagesLoaded: true,
      teacherImagesLoaded: true,
      guardianImagesLoaded: true,
      userRoles,
      showAdminCarousle: 0,
      showTeacherCarousle: 0,
      showGuardianCarousle: 0,

      //   administrators details
      administratorsCarouselData: [
        {
          title: 'Streamlined Operations',
          logo: require('@src/assets/images/HomePage/streamlined-operations.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Data-Driven Insights',
          logo: require('@src/assets/images/HomePage/attendance.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Enhanced Communication',
          logo: require('@src/assets/images/HomePage/generate-student-fee.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Data-Driven Insights',
          logo: require('@src/assets/images/HomePage/fee.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Streamlined Operations',
          logo: require('@src/assets/images/HomePage/add-exam-schedule.png'),
          alt: 'School Logo 7',
        },

        {
          title: 'Data-Driven Insights',
          logo: require('@src/assets/images/HomePage/expense.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Enhanced Communication',
          logo: require('@src/assets/images/HomePage/time-table.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Streamlined Operations',
          logo: require('@src/assets/images/HomePage/notifications-reminders.png'),
          alt: 'School Logo 7',
        },

        {
          title: 'Enhanced Communication',
          logo: require('@src/assets/images/HomePage/active-request.png'),
          alt: 'School Logo 1',
        },
      ],

      empoweringRoleSContent: {
        heading: 'EMPOWERING_ROLES_HEADING',
        paragraph: 'EMPOWERING_ROLES_PARAGRAPH',
      },
      // student details
      studentsCarouselData: [
        {
          title: 'Organized Academic Schedules',
          logo: require('@src/assets/images/HomePage/streamlined-operations.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Easy access to Learning Materials',
          logo: require('@src/assets/images/HomePage/personalized-learning.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Simplified Assignment Submissions',
          logo: require('@src/assets/images/HomePage/assignmentn-submition.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Organized Academic Schedules',
          logo: require('@src/assets/images/HomePage/current-time-table.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Simplified Assignment Submissions',
          logo: require('@src/assets/images/HomePage/assignments.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Easy access to Learning Materials',
          logo: require('@src/assets/images/features/subjectView.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Organized Academic Schedules',
          logo: require('@src/assets/images/HomePage/addSyllabusTemplate.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Simplified Assignment Submissions',
          logo: require('@src/assets/images/HomePage/assignment-submition-settings.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Easy access to Learning Materials',
          logo: require('@src/assets/images/features/chapterView.png'),
          alt: 'School Logo 7',
        },
      ],
      // teacher details
      teachersCarouselData: [
        {
          title: 'Personalized Teaching',
          logo: require('@src/assets/images/HomePage/personalized-learning.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Teacher Details',
          logo: require('@src/assets/images/HomePage/subjects.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Enhanced Collaboration',
          logo: require('@src/assets/images/HomePage/site-setting.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Simplifying Manual Processes',
          logo: require('@src/assets/images/HomePage/streamlined-operations.png'),
          alt: 'School Logo 6',
        },

        {
          title: 'Personalized Teaching',
          logo: require('@src/assets/images/HomePage/section-attendance.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Simplifying Manual Processes',
          logo: require('@src/assets/images/HomePage/gpa-grading-structure.png'),
          alt: 'School Logo 7',
        },

        {
          title: 'Enhanced Collaboration',
          logo: require('@src/assets/images/HomePage/generate-student-fee.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Simplifying Manual Processes',
          logo: require('@src/assets/images/HomePage/simplified-administrative-tasks.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Enhanced Collaboration',
          logo: require('@src/assets/images/HomePage/enhanced-collaboration.png'),
          alt: 'School Logo 7',
        },
      ],
      // guardians details
      guardiansCarouselData: [
        {
          title: 'AI-Powered Student Performance Reports',
          logo: require('@src/assets/images/HomePage/real-time-updates.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Real Time Updates',
          logo: require('@src/assets/images/HomePage/reminder-for-fee.png'),
          alt: 'School Logo 6',
        },

        {
          title: 'Secure Student Pickup',
          logo: require('@src/assets/images/HomePage/secure-student-pickup.png'),
          alt: 'School Logo 6',
        },
        {
          title: 'Real Time Updates',
          logo: require('@src/assets/images/HomePage/fee-notification.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Secure Student Pickup',
          logo: require('@src/assets/images/HomePage/all-request.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'AI-Powered Student Performance Reports',
          logo: require('@src/assets/images/HomePage/expense.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Secure Student Pickup',
          logo: require('@src/assets/images/HomePage/generate-request.png'),
          alt: 'School Logo 7',
        },
        {
          title: 'Real Time Updates',
          logo: require('@src/assets/images/HomePage/real-time-updates.png'),
          alt: 'School Logo 1',
        },
        {
          title: 'Secure Student Pickup',
          logo: require('@src/assets/images/HomePage/all-request.png'),
          alt: 'School Logo 6',
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeCarousel(this.$refs.adminCarousel)
      this.initializeCarousel(this.$refs.teacherCarousel)
      this.initializeCarousel(this.$refs.studentCarousel)
      this.initializeCarousel(this.$refs.guardianCarousel)
    })
  },
  methods: {
    initializeCarousel(carouselRef) {
      const $carousel = $(carouselRef)

      if ($carousel.hasClass('owl-loaded')) {
        $carousel
          .trigger('destroy.owl.carousel')
          .removeClass('owl-loaded owl-carousel owl-theme')
          .find('.owl-stage-outer')
          .children()
          .unwrap()
      }

      $carousel.owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        autoplay: true,
        slideBy: 1,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
          0: { items: 1 },
        },
      })
    },
  },
}
</script>

<style scoped>
:deep(.owl-nav) {
  display: none;
}

:deep(.owl-stage) {
  display: flex !important;
}
:deep(.owl-dots .owl-dot span) {
  cursor: pointer;
  background-color: transparent;
  border-radius: 9999px;
  width: 18px;
  height: 18px;
  border: 2px solid #e9d7fe;
  display: inline-block;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
:deep(.owl-dots .owl-dot span:hover) {
  background-color: #b692f6;
}

:deep(.owl-dots .owl-dot.active span) {
  background-color: #b692f6;
}

:deep(.owl-dots) {
  text-align: center;
  margin-top: 1rem !important;
}
.title-center {
  transform: translateX(-50%);
}

.carousel-height {
  height: 480px;
}
@media (max-width: 1439px) {
  .carousel-height {
    height: 400px;
  }
}
@media (max-width: 768px) {
  .carousel-height {
    height: 300px;
  }
}

.feature-carousel-height {
  height: 441px;
}
@media (max-width: 1439px) {
  .feature-carousel-height {
    height: 400px;
  }
}
@media (max-width: 767px) {
  .feature-carousel-height {
    height: 300px;
  }
}
</style>

<style >
.owl-item {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.owl-item.active {
  visibility: visible;
  opacity: 1;
}
</style>